import * as React from "react";

const MD_QUERY = "(min-width: 768px)";

/** True at md+ (768px) — desktop/laptop layouts for centred modals vs bottom sheets. */
export function useMdViewport(): boolean {
  const [matches, setMatches] = React.useState(() =>
    typeof window !== "undefined" ? window.matchMedia(MD_QUERY).matches : false,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(MD_QUERY);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return matches;
}
